<template>
  <div class="home-foot">
    <div class="foot-top">
      <div class="txt">赛码，多快好省的在线考试平台</div>
      <div class="txt2">
        已帮助超过<span v-html="examStatic.company"></span>家客户完成考试， 现在
        <span v-if="isMobile"><br /></span> 申领100个<span>考试名额</span>
      </div>
      <div class="call">
        <i class="iconfont icondianhua1"></i>
        <span v-html="concat.Landline">400-060-8006</span>
      </div>
      <div class="bottom-btns">
        <a @click="goTest" class="btn-blue-hover">试用</a
        ><a @click="chatShow">咨询顾问</a>
      </div>
      <staticContral></staticContral>
    </div>
    <us-pc-dialog
      :dialogVisible="isPcDialogShow"
      @cancel="isPcDialogShow = false"
    />
  </div>
</template>
<script>
import staticContral from './static.vue'
export default {
  components: {
    staticContral,
  },
  data() {
    return {
      examStatic: {},
      concat: {},
      isMobile: false,
      isPcDialogShow: false,
    }
  },

  methods: {
    goTest() {
      if (this.isMobile) {
        this.isPcDialogShow = true
      } else {
        this.$bus.emit('compRegisterChoose')
      }
    },
    chatShow() {
      this.$bus.emit('chatShow')
    },
  },
  computed: {
    loadConfig() {
      return this.$store.state.app.config
    },
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
    if (this.loadConfig.examStatic) {
      this.examStatic = this.loadConfig.examStatic
    }
    if (this.loadConfig.concat) {
      this.concat = this.loadConfig.concat
    }
  },
  watch: {
    loadConfig(newVal, oldVal) {
      if (newVal.examStatic) {
        if (newVal.examStatic) {
          this.examStatic = newVal.examStatic
        }
        if (newVal.concat) {
          this.concat = newVal.concat
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.home-foot {
  padding: 0px;
  background: #fff;
  height: 520px;
  .foot-top {
    background: url('~@/static/images/foot-top.png');
    background-size: cover;
    height: 520px;
    padding: 80px 0px 0px;
    text-align: center;
    width: 100%;
    font-weight: 300;
    color: #fff;
    .txt {
      display: block;
      font-size: 36px;
      padding: 0px 0px 30px;
    }
    .txt2 {
      span {
        color: #29bdb9;
        font-weight: 400;
      }
    }
    .call {
      color: #29bdb9;
      padding: 30px 0px 0px;
      font-size: 30px;
      font-weight: 400;
      i {
        font-size: 30px;
      }
    }

    .bottom-btns {
      padding: 40px 0px 0px;
      a {
        padding: 6px 30px;
        font-size: 14px;
        cursor: pointer;
        color: #fff;
        border: 2px solid #fff;
        border-radius: 2px;
        margin-right: 20px;
        &:hover {
          border: 2px solid #29bdb9;
          background: #29bdb9;
          color: #fff;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .home-foot {
    height: initial;
    .foot-top {
      height: initial;
      padding: 20px 0 0 0;
      .txt {
        font-size: 24px;
        padding: 20px 0;
      }
      .txt2 {
        font-size: 14px;
        padding: 0 30px;
      }
      .call {
        font-size: 24px;
        padding: 20px 0;
        i {
          font-size: 22px;
        }
      }
      .bottom-btns {
        padding: 10px 0 0 0;
      }
      .paradigm_home_banner_footer {
        margin-top: 40px;
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .home-foot {
    height: initial;
    .foot-top {
      height: initial;
      padding: 20px 0 0 0;
      .txt {
        font-size: 24px;
        padding: 20px 0;
      }
      .txt2 {
        font-size: 14px;
        padding: 0 30px;
      }
      .call {
        font-size: 24px;
        padding: 20px 0;
        i {
          font-size: 22px;
        }
      }
      .bottom-btns {
        padding: 10px 0 0 0;
      }
      .paradigm_home_banner_footer {
        margin-top: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/exam/footer.vue